import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetDispatch, useWidgetSelector } from "../../store/store";
import { setCauseAreaSelection, setGlobalOperationsEnabled, nextPane } from "../../store/actions";
import { State } from "../../store/state";
import { Spinner } from "../../../Spinner/Spinner";
import { CauseAreaDisplayConfig } from "../../types/WidgetProps";
import { usePrefilledCauseAreaIds } from "../hooks";
import panes from "./Panes.module.scss";
import styles from "./SelectionPane.module.scss";
import { getCauseAreaIconById, MultipleCauseAreaIcon } from "../shared/CauseAreaIcon/CauseAreaIcon";

/**
 * First pane: select one-time vs monthly, then choose a cause area or multiple.
 */
interface SelectionPaneProps {
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  accentColor?: string;
}
const DEFAULT_ACCENT_COLOR = "var(--primary)";
export const SelectionPane: React.FC<SelectionPaneProps> = t0 => {
  const $ = _c(58);
  const {
    causeAreaDisplayConfig,
    accentColor
  } = t0;
  const dispatch = useWidgetDispatch();
  const causeAreas = useWidgetSelector(_temp);
  const prefilledCauseAreaIds = usePrefilledCauseAreaIds();
  const {
    operationsPercentageModeByCauseArea: t1
  } = useWidgetSelector(_temp2);
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const operationsPercentageModeByCauseArea = t2;
  let t3;
  if ($[2] !== dispatch || $[3] !== operationsPercentageModeByCauseArea) {
    t3 = id => {
      const selectionType = id && id != -1 ? "single" : "multiple";
      if (selectionType === "multiple") {
        const hasAnyOperationsEnabled = Object.values(operationsPercentageModeByCauseArea).some(_temp3);
        dispatch(setGlobalOperationsEnabled(hasAnyOperationsEnabled));
      }
      dispatch(setCauseAreaSelection(selectionType, id));
      dispatch(nextPane());
    };
    $[2] = dispatch;
    $[3] = operationsPercentageModeByCauseArea;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onSelectArea = t3;
  if (!causeAreas) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className={panes.pane}><div className={panes.paneContainer}><div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}><Spinner /></div></div></div>;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const t4 = causeAreaDisplayConfig?.cause_area_selection_title;
  let t5;
  if ($[6] !== t4) {
    t5 = <h2 className={panes.paneTitle}>{t4}</h2>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onSelectArea) {
    t6 = () => onSelectArea(-1);
    $[8] = onSelectArea;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = accentColor || DEFAULT_ACCENT_COLOR;
  const t8 = accentColor ? "white" : "var(--secondary)";
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = {
      background: t7,
      color: t8,
      border: "1px solid var(--primary)"
    };
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = causeAreaDisplayConfig?.recommendation_button_text;
  let t11;
  if ($[13] !== t10 || $[14] !== t6 || $[15] !== t9) {
    t11 = <div className={styles.buttonsWrapper}><button className={styles.causeAreaButton} key="default" onClick={t6} style={t9} data-cy="cause-area-recommendation">{t10}</button></div>;
    $[13] = t10;
    $[14] = t6;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles.causeAreaButtonsDividerLine} />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== causeAreaDisplayConfig?.below_line_cause_area_ids || $[19] !== causeAreas || $[20] !== onSelectArea || $[21] !== prefilledCauseAreaIds) {
    let t14;
    if ($[23] !== prefilledCauseAreaIds) {
      t14 = ca => ca.isActive || prefilledCauseAreaIds.has(ca.id);
      $[23] = prefilledCauseAreaIds;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    let t15;
    if ($[25] !== causeAreaDisplayConfig?.below_line_cause_area_ids) {
      t15 = ca_0 => {
        const belowLineIds = causeAreaDisplayConfig?.below_line_cause_area_ids || [4, 5];
        return !belowLineIds.includes(ca_0.id);
      };
      $[25] = causeAreaDisplayConfig?.below_line_cause_area_ids;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] !== onSelectArea) {
      t16 = ca_1 => <button className={styles.causeAreaButton} key={ca_1.id} onClick={() => onSelectArea(ca_1.id)} data-cy={`cause-area-${ca_1.id}`}>{getCauseAreaIconById(ca_1.id)}{ca_1.widgetDisplayName || ca_1.name}</button>;
      $[27] = onSelectArea;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    t13 = causeAreas.filter(t14).filter(t15).map(t16);
    $[18] = causeAreaDisplayConfig?.below_line_cause_area_ids;
    $[19] = causeAreas;
    $[20] = onSelectArea;
    $[21] = prefilledCauseAreaIds;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[29] !== onSelectArea) {
    t14 = () => onSelectArea(undefined);
    $[29] = onSelectArea;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      marginTop: "20px"
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MultipleCauseAreaIcon />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = causeAreaDisplayConfig?.multiple_cause_areas_button_text;
  let t18;
  if ($[33] !== t14 || $[34] !== t17) {
    t18 = <button className={styles.causeAreaButton} onClick={t14} style={t15} data-cy="cause-area-multiple">{t16}{t17}</button>;
    $[33] = t14;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t13 || $[37] !== t18) {
    t19 = <div className={styles.buttonsWrapper}>{t13}{t18}</div>;
    $[36] = t13;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className={styles.causeAreaButtonsDividerLine} />;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== causeAreaDisplayConfig?.below_line_cause_area_ids || $[41] !== causeAreas || $[42] !== onSelectArea || $[43] !== prefilledCauseAreaIds) {
    let t22;
    if ($[45] !== prefilledCauseAreaIds) {
      t22 = ca_2 => ca_2.isActive || prefilledCauseAreaIds.has(ca_2.id);
      $[45] = prefilledCauseAreaIds;
      $[46] = t22;
    } else {
      t22 = $[46];
    }
    let t23;
    if ($[47] !== causeAreaDisplayConfig?.below_line_cause_area_ids) {
      t23 = ca_3 => {
        const belowLineIds_0 = causeAreaDisplayConfig?.below_line_cause_area_ids || [4, 5];
        return belowLineIds_0.includes(ca_3.id);
      };
      $[47] = causeAreaDisplayConfig?.below_line_cause_area_ids;
      $[48] = t23;
    } else {
      t23 = $[48];
    }
    let t24;
    if ($[49] !== onSelectArea) {
      t24 = ca_4 => <button className={styles.causeAreaButton} key={ca_4.id} onClick={() => onSelectArea(ca_4.id)} data-cy={`cause-area-${ca_4.id}`}>{getCauseAreaIconById(ca_4.id)}{ca_4.widgetDisplayName || ca_4.name}</button>;
      $[49] = onSelectArea;
      $[50] = t24;
    } else {
      t24 = $[50];
    }
    t21 = causeAreas.filter(t22).filter(t23).map(t24);
    $[40] = causeAreaDisplayConfig?.below_line_cause_area_ids;
    $[41] = causeAreas;
    $[42] = onSelectArea;
    $[43] = prefilledCauseAreaIds;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[51] !== t21) {
    t22 = <div className={styles.buttonsWrapper}>{t21}</div>;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t11 || $[54] !== t19 || $[55] !== t22 || $[56] !== t5) {
    t23 = <div className={panes.pane}><div className={panes.paneContainer}><div>{t5}{t11}{t12}{t19}{t20}{t22}</div></div></div>;
    $[53] = t11;
    $[54] = t19;
    $[55] = t22;
    $[56] = t5;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
};
function _temp(state) {
  return state.layout.causeAreas;
}
function _temp2(state_0) {
  return state_0.donation;
}
function _temp3(enabled) {
  return enabled;
}